module.exports = __webpack_public_path__ + "img/vat-false.a6c9348f.png";